import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';

const loader = keyframes`
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
`;

const StyledLoaderContainer = styled(FlexContainer)`
  @media only screen and (max-width: 1157px) {
    height: 100vh;
    padding: 0;
  }
`;
const StyledLoader = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
div {
  position: absolute;
  border: 4px solid #3c1b63;
  opacity: 1;
  border-radius: 50%;
  animation: ${loader} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
 div:nth-child(2) {
  animation-delay: -0.5s;
`;

const AffiliateLoader = () => (
  <StyledLoaderContainer
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    padding="42px 0 178px 38px"
    tabletPadding="58px 24px 333px 24px"
    mobilePadding="22px 16px 112px 16px"
    width="800px"
    mobileWidth="100%"
    tabletWidth="100%"
  >
    <StyledLoader>
      <div />
      <div />
    </StyledLoader>
  </StyledLoaderContainer>
);

export default AffiliateLoader;
